// Under the hood Teams Desktop App uses Electron
// The version of Chromium bundled is 85 and since crypto.randomUUID requires Chromium >= 92 we need to polyfill it
const generateUUID = () => {
    let timeStamp = Date.now();
    let timeSincePageLoadMs = (performance?.now && performance.now() * 1000) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replaceAll(/[xy]/g, (c) => {
        let randomNumber = Math.random() * 16;
        if (timeStamp > 0) {
            randomNumber = Math.trunc((timeStamp + randomNumber) % 16);
            timeStamp = Math.floor(timeStamp / 16);
        }
        else {
            randomNumber = Math.trunc((timeSincePageLoadMs + randomNumber) % 16);
            timeSincePageLoadMs = Math.floor(timeSincePageLoadMs / 16);
        }
        return (c === 'x' ? randomNumber : (randomNumber & 0x3) | 0x8).toString(16);
    });
};
if (globalThis.crypto === undefined) {
    Object.defineProperty(globalThis, 'crypto', {
        value: {
            randomUUID: generateUUID,
        },
    });
}
else if (globalThis.crypto.randomUUID === undefined) {
    Object.assign(globalThis.crypto, {
        randomUUID: generateUUID,
    });
}
export {};
